import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/themeThree/search_icon.png'
import _imports_1 from '@/assets/themeFour/searchNodata.png'
import _imports_2 from '@/assets/common/loadMore.png'


const _hoisted_1 = { class: "mainPage" }
const _hoisted_2 = { class: "stickyContent" }
const _hoisted_3 = { class: "searchField" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_6 = {
  key: 0,
  class: "gameContainer"
}
const _hoisted_7 = {
  key: 0,
  class: "noDataContainer"
}
const _hoisted_8 = {
  key: 0,
  class: "gameProgressBar"
}
const _hoisted_9 = { class: "bar" }
const _hoisted_10 = { style: {"margin-left":"10px"} }
const _hoisted_11 = {
  key: 2,
  class: "loading_btn"
}
const _hoisted_12 = {
  key: 1,
  class: "gameContainer"
}
const _hoisted_13 = {
  key: 0,
  class: "noDataContainer"
}
const _hoisted_14 = {
  key: 2,
  class: "gameContainer"
}
const _hoisted_15 = {
  key: 0,
  class: "noDataContainer"
}
const _hoisted_16 = {
  key: 3,
  class: "gameContainer"
}
const _hoisted_17 = {
  key: 0,
  class: "noDataContainer"
}

import { ref, computed, watch, inject, onMounted, nextTick } from 'vue';
import { debounce, fetchGameList, getGameSpecialCategories, goToPlayGame, TAB_LIST_THEME4 } from '@/view/home/supportScript';
import { useRoute, useRouter } from 'vue-router';
import GameCard from '../game/components/gameCard.vue';
import { useGameStore } from '@/stores/games';
const PAGE_SIZE = 20

export default /*@__PURE__*/_defineComponent({
  __name: 'gameSerchPage',
  emits: ['goToPlayGame'],
  setup(__props, { expose: __expose, emit: __emit }) {

const router = useRouter()
const route = useRoute()
const gameStore = useGameStore()
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const show = ref(false)
const localValue = ref('')
const openPopup = () => {
    show.value = true;
    getGameList()
}
const tabList = ref(TAB_LIST_THEME4)
const active = ref(2);
const gameList = ref<any>([])
const gameCount = ref(0)
const pageNum = ref(1)
const loading = ref(false)
const pageSize = ref(PAGE_SIZE)
const showLoadMore = ref(false)
const hotGames = ref<any>([])
const recentGames = ref<any>([])
const favoriteGames = ref<any>([])
const gameSet = computed(() => ({
    gameCount: gameCount.value,
    gameList: gameList.value,
    showLoadMore: showLoadMore.value,
    loading: loading.value
}))
const emits = __emit
const backNavigation = () => {
    router.push('/home')
}

const loadMoreGame = () => {
    if (gameCount.value > pageNum.value * pageSize.value) {
        pageNum.value = pageNum.value + 1
        getGameList()
    }
}

const getGameList = async () => {
    loading.value = true

    const { rows, total } = await fetchGameList(pageNum.value, pageSize.value, localValue.value)

    loading.value = false
    gameList.value = [...gameList.value, ...rows]
    gameCount.value = total
    showLoadMore.value = total > pageNum.value * pageSize.value
}
const GoToPlayGame = (id: any, makerId: any, favorite: number, favId: number) => {
    goToPlayGame(router, openRegisterLoginPopup, id, makerId, favorite, favId)
}
const resetList = () => {
    pageNum.value = 1;
    gameList.value = [];
};
// const debouncedSearch = debounce(() => {
//     resetList()
//     getGameList()
// }, 500)

// watch(localValue, () => {
//     debouncedSearch()
// })
const onClickTab = async (value: any) => {
    active.value = value.name
    localValue.value = ''
    gameList.value = [];
    showLoadMore.value = false

    await nextTick();

    setTimeout(() => {
        window.scrollTo(0, 0);

        const containers = document.querySelectorAll('.gameContainer');
        containers.forEach(el => {
            el.scrollTop = 0;
        });

        const rightContainers = document.querySelectorAll('.right_container');
        rightContainers.forEach(el => {
            el.scrollTop = 0;
        });
    }, 0);
}
const resetgameList = () => {
    favoriteGames.value = []
}
const getGameTabData = async () => {
    resetgameList()
    const { favoriteGameList, hotGameList, recentGameList } = await getGameSpecialCategories()
    favoriteGames.value = favoriteGameList
    recentGames.value = recentGameList
    hotGames.value = hotGameList
}
const searchGames = () => {
    active.value = 1
    resetList()
    getGameList()
}
onMounted(() => {
    if (route.query.tab) {
        active.value = Number(route.query.tab)
    }
    getGameTabData()

})
__expose({
    openPopup
})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_row, { class: "popHeader" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "2",
            style: {"display":"flex","align-items":"center"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, {
                name: "arrow-left",
                size: "20",
                onClick: backNavigation
              })
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "20",
            class: "Poptitle"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.toLookFor')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_field, {
          modelValue: localValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
          type: "text",
          placeholder: _ctx.$t('home.searchGames'),
          class: "custom-field"
        }, {
          "right-icon": _withCtx(() => [
            _createElementVNode("div", {
              class: "left-section",
              onClick: searchGames
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                width: "15%",
                style: {"opacity":"0.4"}
              }, null, -1)
            ]))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_tabs, {
          id: "gameSearchTabs",
          ellipsis: false,
          active: active.value,
          "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((active).value = $event)),
          onClickTab: onClickTab
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_tab, {
                title: _ctx.$t(item.name),
                key: index,
                name: item.id
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_van_icon, {
                      name: item.icon,
                      style: {"padding-right":"10px"}
                    }, null, 8, ["name"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(item.name)), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["title", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ]),
    (active.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (gameSet.value?.gameList?.length < 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[3] || (_cache[3] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "",
                  width: "60%"
                }, null, -1)
              ])))
            : _createCommentVNode("", true),
          _createVNode(_component_van_row, { class: "game_container" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "24",
                class: "right_container"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_row, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameSet.value?.gameList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_van_col, {
                          span: "8",
                          class: "game_item",
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createVNode(GameCard, {
                              gameImage: item.customIcon,
                              onClickGameCard: ($event: any) => (GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)),
                              gameTypeId: item.id,
                              gameIsFavorite: item.isFavorite,
                              onUpdateGameCategories: getGameTabData
                            }, null, 8, ["gameImage", "onClickGameCard", "gameTypeId", "gameIsFavorite"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  (gameSet.value?.gameList.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", {
                            class: "progress",
                            style: _normalizeStyle({ width: gameSet.value?.gameList.length / gameSet.value.gameCount < 1 ? gameSet.value?.gameList.length * 100 / gameSet.value.gameCount + '%' : '100%' })
                          }, null, 4),
                          _createElementVNode("div", {
                            class: "progress-end-dot",
                            style: _normalizeStyle({ left: `calc(${gameSet.value?.gameList.length * 100 / gameSet.value.gameCount}% - 6px)` })
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(Math.round(gameSet.value?.gameList.length / gameSet.value.gameCount * 100)) + "% ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!gameSet.value?.loading && gameSet.value?.showLoadMore)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "load_more_btn",
                        onClick: loadMoreGame
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.loadMore')) + " ", 1),
                        _cache[4] || (_cache[4] = _createElementVNode("img", {
                          src: _imports_2,
                          alt: ""
                        }, null, -1))
                      ]))
                    : _createCommentVNode("", true),
                  (gameSet.value?.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_van_loading, { size: "20" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.loading')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (active.value == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (hotGames.value?.length < 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[5] || (_cache[5] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "",
                  width: "60%"
                }, null, -1)
              ])))
            : (_openBlock(), _createBlock(_component_van_row, {
                key: 1,
                class: "game_container"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "24",
                    class: "right_container"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotGames.value, (item, index) => {
                            return (_openBlock(), _createBlock(_component_van_col, {
                              span: "8",
                              class: "game_item",
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(GameCard, {
                                  gameImage: item.customIcon,
                                  onClickGameCard: ($event: any) => (GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)),
                                  gameTypeId: item.id,
                                  gameIsFavorite: item.isFavorite,
                                  onUpdateGameCategories: getGameTabData
                                }, null, 8, ["gameImage", "onClickGameCard", "gameTypeId", "gameIsFavorite"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true),
    (active.value == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (recentGames.value?.length < 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[6] || (_cache[6] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "",
                  width: "60%"
                }, null, -1)
              ])))
            : (_openBlock(), _createBlock(_component_van_row, {
                key: 1,
                class: "game_container"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "24",
                    class: "right_container"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentGames.value, (item, index) => {
                            return (_openBlock(), _createBlock(_component_van_col, {
                              span: "8",
                              class: "game_item",
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(GameCard, {
                                  gameImage: item.customIcon,
                                  onClickGameCard: ($event: any) => (GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)),
                                  gameTypeId: item.id,
                                  gameIsFavorite: item.isFavorite,
                                  onUpdateGameCategories: getGameTabData
                                }, null, 8, ["gameImage", "onClickGameCard", "gameTypeId", "gameIsFavorite"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true),
    (active.value == 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (favoriteGames.value?.length < 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[7] || (_cache[7] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "",
                  width: "60%"
                }, null, -1)
              ])))
            : (_openBlock(), _createBlock(_component_van_row, {
                key: 1,
                class: "game_container"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "24",
                    class: "right_container"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favoriteGames.value, (item, index) => {
                            return (_openBlock(), _createBlock(_component_van_col, {
                              span: "8",
                              class: "game_item",
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(GameCard, {
                                  gameImage: item.customIcon,
                                  onClickGameCard: ($event: any) => (GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)),
                                  gameTypeId: item.id,
                                  gameIsFavorite: item.isFavorite,
                                  onUpdateGameCategories: getGameTabData
                                }, null, 8, ["gameImage", "onClickGameCard", "gameTypeId", "gameIsFavorite"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})